// DO NOT EDIT -- generated from fs/services/lassie/lassie.proto

export namespace IssueTrackingPublic {

  export const GetProjectsEndpoint = "/grpc/lassie.IssueTrackingPublic/GetProjects";
  export function GetProjects(sender: (req: {}, endpoint: string) => Promise<GetProjectsResponse>, req: {}): { promise: () => Promise<GetProjectsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetProjectsEndpoint),
      endpoint: GetProjectsEndpoint
    };
  }

  export const GetProductTeamsEndpoint = "/grpc/lassie.IssueTrackingPublic/GetProductTeams";
  export function GetProductTeams(sender: (req: {}, endpoint: string) => Promise<GetProductTeamsResponse>, req: {}): { promise: () => Promise<GetProductTeamsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetProductTeamsEndpoint),
      endpoint: GetProductTeamsEndpoint
    };
  }

  export const CreateIssueEndpoint = "/grpc/lassie.IssueTrackingPublic/CreateIssue";
  export function CreateIssue(sender: (req: CreateIssueRequest, endpoint: string) => Promise<CreateIssueResponse>, req: CreateIssueRequest): { promise: () => Promise<CreateIssueResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateIssueEndpoint),
      endpoint: CreateIssueEndpoint
    };
  }
}

export interface GetProjectsResponse {
  issueProjects: IssueProject[];
}

export interface GetProductTeamsResponse {
  productTeams: ProductTeam[];
}

export interface IssueProject {
  id: string;
  name: string;
  key: string;
}

export interface ProductTeam {
  id: string;
  name: string;
}

export interface CreateIssueRequest {
  name: string;
  description: string;
  projectKey: string;
  issueType: IssueType;
  labels: string[];
  teamId: string;
}

export interface CreateIssueResponse {
  id: string;
  key: string;
  url: string;
}

export enum IssueType {
  ISSUE_TYPE_BUG = 0,
  ISSUE_TYPE_SUBTASK = 1,
  ISSUE_TYPE_STORY = 2,
  ISSUE_TYPE_EPIC = 3
}
